import { render, staticRenderFns } from "./EditarEstudoForm.vue?vue&type=template&id=2c5851f4&scoped=true&"
import script from "./EditarEstudoForm.vue?vue&type=script&lang=js&"
export * from "./EditarEstudoForm.vue?vue&type=script&lang=js&"
import style0 from "./EditarEstudoForm.vue?vue&type=style&index=0&id=2c5851f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5851f4",
  null
  
)

export default component.exports